import React, { Component } from 'react'
import equal from 'fast-deep-equal';

export class DealerTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dealers: null,
        }
    }

    componentDidUpdate(prevProps) {
        if(!equal(this.props, prevProps))
            this.setState({dealers: this.props.dealers});
    }

    render() {
        if(!this.state.dealers)
            return <div />;

        const {dealers} = this.state;
        
        return (
            <table className="fb_dealers">
                <tbody>
                    <tr className="tHeader">
                        <th>Company</th>
                        <th>Contact info</th>
                    </tr>
                    {dealers.map((dealer,key) => (
                        <tr key={key}>
                            <td>
                                <b>{dealer.name}</b>
                                <br />{dealer.adres}
                            </td>
                            <td style={{width: "20%"}}>
                                <a href={`tel:${dealer.tel}`} title={`Call ${dealer.name}`}>
                                    <i className="material-icons">phone</i>
                                    {dealer.tel}
                                </a>
                                <br />
                                <a href={`mailto:${dealer.mail}`} title={`Send mail to ${dealer.name}`}>
                                    <i className="material-icons">email</i>
                                    {dealer.mail}
                                </a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        )
    }
}

export default DealerTable